var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHonkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.924822C16.7059 -0.0328031 15.1765 -0.272209 13.7647 0.326306L4.47059 3.43859H3.52941C1.52941 3.43859 0 4.99473 0 7.02968V9.42375C0 11.4587 1.52941 13.0148 3.52941 13.0148H4.47059L4.70588 13.1345V15.4089C4.70588 15.768 4.94118 16.1271 5.17647 16.3665L8.70588 18.7606C8.94118 18.8803 9.17647 19 9.41177 19C9.64706 19 9.76471 19 10 18.8803C10.3529 18.6409 10.5882 18.2818 10.5882 17.803V15.0498L13.7647 16.1271C14.2353 16.2468 14.8235 16.3665 15.2941 16.3665C16.2353 16.3665 17.1765 16.0074 18 15.4089C19.2941 14.4513 20 13.1345 20 11.5784V4.87503C20 3.31889 19.2941 1.88245 18 0.924822ZM2.35294 9.42375V7.02968C2.35294 6.31147 2.82353 5.83265 3.52941 5.83265V10.6208C2.82353 10.6208 2.35294 10.142 2.35294 9.42375ZM8.23529 15.5286L7.05882 14.6907V13.8528L8.23529 14.2119V15.5286ZM17.6471 11.5784C17.6471 12.4163 17.2941 13.0148 16.7059 13.4937C16.1176 13.9725 15.2941 14.0922 14.5882 13.8528L9.88235 12.2966L6.35294 11.0996L5.88235 10.9799V5.47354L14.5882 2.48096C15.2941 2.24156 16.1176 2.36126 16.7059 2.84007C17.2941 3.31889 17.6471 4.03711 17.6471 4.75532V11.5784Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonkIcon);
export default __webpack_public_path__ + "static/media/honk-icon.e5d00eb7b51a784f0e1a9ab57caf1693.svg";
export { ForwardRef as ReactComponent };